import {
  isTransferIntervalTypeMonthly,
  isTransferIntervalTypeWeekly,
  TRANSFER_INTERVAL_TYPE_ENUM
} from '../enums/transfer-settings.enum'

export function recipientType (type) {
  if (['Física', 'Individual'].includes(type)) {
    return 'individual'
  }

  return 'company'
}

export function recipientStatus (status) {
  if (['Ativo', 'Active', 'active'].includes(status)) {
    return 'active'
  }

  return 'inactive'
}

export function backAccountType (type) {
  if (['Poupança', 'Savings'].includes(type)) {
    return 'savings'
  }

  if (['conjunct_savings'].includes(type)) {
    return 'conjunct_savings'
  }

  if (['conjunct_checking'].includes(type)) {
    return 'conjunct_checking'
  }

  return 'checking'
}

export function prepaymentType (type) {
  if (['Recebimento por volume', 'Receipt by volume', 'full'].includes(type)) {
    return 'full'
  }

  return '1025'
}

export function transferInterval (type) {
  if (isTransferIntervalTypeWeekly(type)) {
    return TRANSFER_INTERVAL_TYPE_ENUM.WEEKLY.label
  }

  if (isTransferIntervalTypeMonthly(type)) {
    return TRANSFER_INTERVAL_TYPE_ENUM.MONTHLY.label
  }

  return TRANSFER_INTERVAL_TYPE_ENUM.DAILY.label
}
